import { FuseAnimate } from '@fuse';
import { Avatar, Card, CardContent, IconButton, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMail, MdPhone } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/MeusConvitesActions';
import reducer from './Store/Reducers/MeusConvitesReducer';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    header: {},
    flipBackground: theme.palette.text.primary,
    btnVinculo: {
        position: 'absolute',
        top: 0,
        right: 0,
        opacity: 0,
        zIndex: 999
    },
    divAction: {
        backgroundColor: '#E6E6E6',
    },
    cardContent: {
        background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + theme.palette.primary.main + ' 100%)',
        color: '#666',
        padding: '6px 16px'
    }

});

class MeusConvitesCard extends XAPPComponent {

    render() {
        const { item, classes, save, idpessoa } = this.props;

        return (
            <div className="w-full h-300 px-8 pb-8" id={"divmain_" + item.idchave}>
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <Card elevation={1} className="h-300 w-full">
                        <CardContent className={clsx(classes.cardContent, "flex flex-col flex-auto overflow-hidden")}>
                            <div className="flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start">
                                <Avatar className="w-96 h-96" src={item.remetentedados.foto ? item.remetentedados.foto : "assets/images/avatars/profile.png"} />
                                <div className="flex flex-col w-full items-start px-16">
                                    <Typography className="text-white" variant="h6" color="textSecondary">{item.remetentedados.nome}</Typography>
                                    <div className="flex items-center justify-center">
                                        {item.remetentedados.fone && item.remetentedados.fone.length > 0 &&
                                            <a
                                                className="font-medium"
                                                href={"tel:" + item.remetentedados.fone}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <IconButton
                                                    key={"fone" + item.idchave}
                                                    className="text-20 p-10"
                                                >
                                                    <MdPhone className="text-green text-24" />
                                                </IconButton>
                                            </a>
                                        }
                                        {item.remetentedados.email && item.remetentedados.email.length > 0 &&
                                            <a
                                                className="font-medium"
                                                href={"mailto:" + item.remetentedados.email}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <IconButton
                                                    key={"fone" + item.idchave}
                                                    className="text-20 p-10"
                                                >
                                                    <MdMail className="text-yellow-dark text-24" />
                                                </IconButton>
                                            </a>
                                        }
                                        {item.remetentedados.fone && item.remetentedados.fone.length > 0 &&
                                            <a
                                                className="font-medium"
                                                href={"https://wa.me/" + (item.remetentedados.fone.substr(0, 3).includes("+55") ? ("+55" + item.remetentedados.fone) : item.remetentedados.fone)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <IconButton
                                                    key={"Whatsapp" + item.idchave}
                                                    className="text-20 p-10"
                                                >
                                                    <FaWhatsapp className="text-green text-24" />
                                                </IconButton>
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>

                        </CardContent>
                        <Typography className="text-center w-full text-16 py-8" color="textSecondary">
                            {item.descricao}
                        </Typography>
                        {[0, 1].includes(item.status) &&
                            <div className={clsx(classes.divAction, "flex flex-row w-full items-center justify-end p-8")}>
                                {item.status === 1 &&
                                    <XAPPButton
                                        type={"button"}
                                        color="primary"
                                        className="bg-red hover:bg-red text-white mr-8"
                                        onClick={() => save({ ...item, status: -1 }, idpessoa)}
                                        variant="contained"
                                        label={md.mobile() === null && md.tablet() === null ? "Revogar" : ""}
                                        tooltip={{ "title": "Revogar", "placement": "top" }}
                                    />
                                }
                                {item.status === 0 &&
                                    <XAPPButton
                                        type={"button"}
                                        color="primary"
                                        className="bg-red hover:bg-red text-white mr-8"
                                        onClick={() => save({ ...item, status: -1 }, idpessoa)}
                                        variant="contained"
                                        label={"Recusar"}
                                        tooltip={{ "title": "Recusar", "placement": "top" }}
                                    />
                                }
                                {item.status === 0 &&
                                    <XAPPButton
                                        type={"button"}
                                        color="primary"
                                        className="bg-green hover:bg-green text-white mr-8"
                                        onClick={() => save({ ...item, status: 1 }, idpessoa)}
                                        variant="contained"
                                        label={"Aceitar"}
                                        tooltip={{ "title": "Aceitar", "placement": "top" }}
                                    />
                                }
                            </div>
                        }
                    </Card>
                </FuseAnimate>
            </div>
        )
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ MeusConvites }) {
    return {
        MeusConvites: MeusConvites,
    }
}

export default withReducer('MeusConvites', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MeusConvitesCard))));
